import { mutator } from 'satcheljs';
import store from '../store/Store';
import { pivotToggled } from '../actions/internalActions';

mutator(pivotToggled, actionMessage => {
    const indexToSet = store.enabledDisabledPivots
        .map(pivot => pivot.InboxClassificationFilter)
        .indexOf(actionMessage.pivot.InboxClassificationFilter);

    store.enabledDisabledPivots[indexToSet].isEnabled = !store.enabledDisabledPivots[indexToSet]
        .isEnabled;
});
